import { BaseProduct, ProductBuilderMachineContext } from '../types';

type GetPleatType = (context: ProductBuilderMachineContext) => string[];
type ProductHasPleatTypeOption = (product: BaseProduct) => boolean;
type GetVariantOptionKeyForPleatType = (
  product: BaseProduct,
) => PleatTypeKey | null;

type PleatTypeKey = 'option1' | 'option2' | 'option3';
type ProductHasVariantWithPleatType = (
  pleatType: string,
) => (product: BaseProduct) => boolean;

export const productHasPleatTypeOption: ProductHasPleatTypeOption = product =>
  product.options.includes('Pleat Type');

export const getVariantOptionKeyForPleatType: GetVariantOptionKeyForPleatType = product => {
  const pleatTypeIndex = product.options.findIndex(
    option => option === 'Pleat Type',
  );
  if (pleatTypeIndex === -1) return null;

  return `option${pleatTypeIndex + 1}` as PleatTypeKey;
};

export const getPleatType: GetPleatType = context => {
  const { products } = context;

  const pleatTypeKey =
    products.length > 0 ? getVariantOptionKeyForPleatType(products[0]) : null;
  if (pleatTypeKey === null) return [];

  return Array.from(
    new Set(
      products
        .map(({ variants }) =>
          variants.map(variant => {
            return variant[pleatTypeKey] as string;
          }),
        )
        .flat(),
    ),
  );
};

export const productHasVariantWithPleatType: ProductHasVariantWithPleatType = pleatType => product => {
  const optionKey = getVariantOptionKeyForPleatType(product);
  if (optionKey === null) return false;

  return product.variants.some(variant => variant[optionKey] === pleatType);
};
